// extracted by mini-css-extract-plugin
export default {"image":"SingleSelect_image__7sQd6","imageImg":"SingleSelect_imageImg__sjuSQ","imagePh":"SingleSelect_imagePh__tUeDa"};